import { render, staticRenderFns } from "./OrganizationContactForm.vue?vue&type=template&id=3b851abc&scoped=true&"
import script from "./OrganizationContactForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationContactForm.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationContactForm.vue?vue&type=style&index=0&id=3b851abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b851abc",
  null
  
)

export default component.exports